import './App.scss';

import React, {Suspense, useEffect} from 'react';

import FullLoader from './app/components/FullLoader';
import {NetworkStatus} from './app/components/NetworkStatus/NetworkStatus';
import {useLinkedinInsight} from './app/hooks/useLinkedinInsight';
import {setupCookie} from './app/utils/CookieUtil';
import {lazyRetry} from './app/utils/LazyRetryUtil';

import {Redirect, Route, Switch} from 'react-router-dom';

const IEWarningScreen = React.lazy(() => lazyRetry(() => import('./app/screens/ie-warning/IEWarningScreen')));
const PubScreen = React.lazy(() => lazyRetry(() => import('./app/screens/public/PubScreen')));
const ProfileAware = React.lazy(() => lazyRetry(() => import('./ProfileAware')));
const PublicErrorScreen = React.lazy(() =>
    lazyRetry(() => import('./app/screens/public-error/PublicErrorScreen')),
);

// const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
// const SENTRY_URL = process.env.REACT_APP_SENTRY_URL || '';

// Sentry.init({
//     dsn: SENTRY_DSN,
//     integrations: [
//         new Sentry.BrowserTracing({
//             tracePropagationTargets: [SENTRY_URL],
//         }),
//         new Sentry.Replay(),
//     ],
//     tracesSampleRate: 1.0,
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
// });

const App = () => {
    const isIE = (window as Window & typeof globalThis & {documentMode?: number}).documentMode;

    if (isIE) {
        return <IEWarningScreen />;
    }

    useEffect(setupCookie, []);

    const handleCspViolation = (_: SecurityPolicyViolationEvent) => {};

    useEffect(() => {
        document.addEventListener('securitypolicyviolation', handleCspViolation);

        return () => {
            document.removeEventListener('securitypolicyviolation', handleCspViolation);
        };
    }, []);

    useLinkedinInsight();

    return (
        <div>
            <NetworkStatus />
            <Switch>
                <Route path='/pub'>
                    <Suspense fallback={<FullLoader />}>
                        <PubScreen />
                    </Suspense>
                </Route>
                <Route path='/error/:errorCode'>
                    <Suspense fallback={<FullLoader />}>
                        <PublicErrorScreen />
                    </Suspense>
                </Route>
                <Redirect path='/' to='/login' exact={true} />
                <Route>
                    <Suspense fallback={<FullLoader />}>
                        <ProfileAware />
                    </Suspense>
                </Route>
            </Switch>
        </div>
    );
};

export default App;
